import { ref } from "vue";

export function useEmailActions(
  loadConversationsForChannel: (channel: string) => Promise<void>,
  toast: any
) {
  const showEmailCompositionModal = ref(false);

  async function handleEmailSend(emailData: any) {
    try {
      if (!emailData.account_id) {
        toast.error("Please select an email account");
        return;
      }
      const Unipile = (await import("@/services/unipile/unipile")).default;
      await Unipile.sendEmail(emailData);
      toast.success("Email sent successfully");
      showEmailCompositionModal.value = false;
      await loadConversationsForChannel("email");
    } catch (error) {
      console.error("Failed to send email:", error);
      toast.error((error as any).response?.data?.message || "Failed to send email");
    }
  }

  function handleEmailAttach() {
    // Empty stub — template binds @attach="handleEmailAttach"
  }

  async function handleEmailScheduleSend(payload: any) {
    try {
      const ScheduledEmailService = (await import("@/services/scheduled-email")).default;
      await ScheduledEmailService.createScheduledEmail(payload);
      toast.success("Email scheduled successfully");
      showEmailCompositionModal.value = false;
      await loadConversationsForChannel("email");
    } catch (error) {
      console.error("Failed to schedule email:", error);
      toast.error((error as any).response?.data?.message || "Failed to schedule email");
    }
  }

  return {
    showEmailCompositionModal,
    handleEmailSend,
    handleEmailAttach,
    handleEmailScheduleSend,
  };
}
